
type EventTypeTextType = {
  eventType: 'absent_customer' | 'wrong_address',
  brandName: string,
  carrier: string,
  trackingCode: string,
  addressString: string
}

export default function EventTypeText({ eventType, brandName, carrier, trackingCode, addressString }: EventTypeTextType) {
  return (
    <div>
      <h3 className="text-lg leading-6 font-medium text-gray-900">
        Tu pedido {brandName && 'de ' + brandName} no pudo ser entregado ya que no {eventType === 'absent_customer' ? 'se encontraba nadie en el domicilio.' : 'fue posible encontrar la dirección indicada.'}
      </h3>
      <p className="mt-1 max-w-2xl text-sm text-gray-700">
        <span>{eventType === 'absent_customer' ? `La paquetería realizará un nuevo intento de entrega al siguiente día hábil.` : `Para realizar un nuevo intento de entrega, se necesita validar la dirección correcta del domicilio.`}</span>
        <br />
        <span>{eventType === 'absent_customer' ? `Por favor, revisa que la información sea correcta. Si lo deseas puedes agregar más información.` : `Revisa y confirma la información para actualizar la información.`}</span>
      </p>
      {eventType === 'wrong_address' && (
        <p className="mt-1 max-w-2xl text-sm text-gray-700">Dirección registrada: <b>{addressString}</b></p>
      )}
      <p className="mt-1 max-w-2xl text-sm text-gray-700">
        Paquetería: <b>{carrier}</b>
        <br />
        Número de rastreo: <b>{trackingCode}</b>
      </p>

    </div>
  )
}